module.exports = __webpack_public_path__ + "static/media/objective.f6e96f14.md";